<template>
  <div class="">
    <transition name='fade'>
      <countdown v-on:timerComplete="episodeUnlock()" v-on:timerUpdated="episodeLock()" :episodeEnded="episodeEnded" v-if="timerUnlocked && parseInt(chapter) === 1 && parseInt(episode) > 1"></countdown>
    </transition>
    <transition name='fade'>
      <div v-if="storyUnlocked || parseInt(chapter) > 1 || parseInt(episode) === 1">
        <div class="card is-shadowless">
          <div class="card-header is-shadowless">
          </div>
          <div class="card-content">
            <div>{{episodeTitle}}</div>
            <episode-title :title="episodes[episode].title"></episode-title>
            <div v-html="require('./../components/locations/' + episode + '_' + chapter + '.html')"></div>
          </div>
          <div v-if="errorMsg" class="notification is-light">{{errorMsg}}</div>
        </div>
        <div class="columns is-marginless mt-6">
          <div class="column" v-if="!locationIsSet">
            <button class="button" @click="checkIn()">I'm there</button>
          </div>
           <div class="column" v-if="locationIsSet">
            <button class="button" @click="checkLocation()" v-if="!inLocation && locationId !== 0">I'm there</button>
            <button class="button" @click="startReading()" v-if="inLocation || locationId === 0">Start reading</button>
          </div>
            <div class="column">
              <p class="mb-2 outliers">
                <span ref="outlier1">it’s not always possible </span>
                <span ref="outlier2">to find your way back</span>
                <span ref="outlier3">, no matter</span>
                <span ref="outlier4"> how hard you try</span>
              </p>
              <transition name="fade">
                <button class="button" @click="startReading" v-if="timesChecked >= 5">Read here</button>
              </transition>
            </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import firebase from 'firebase'
import Countdown from '@/components/CountdownComp.vue'
import EpisodeTitle from '@/components/EpisodeTitle.vue'
export default {

  name: 'LocationPage',

  data () {
    return {
      episodes: this.$root.config.episodes,
      locationInfo: this.$root.config.locations,
      inLocation: false,
      errorMsg: null,
      timerUnlocked: false,
      storyUnlocked: false,
      timesChecked: 0
    }
  },
  watch: {
    storyUnlocked (unlocked) {
      if (unlocked === true) {
        this.$refs.outlier1.style.opacity = '0'
        this.$refs.outlier2.style.opacity = '0'
        this.$refs.outlier3.style.opacity = '0'
        this.$refs.outlier4.style.opacity = '0'
      }
    },
    timesChecked (times) {
      if (this.storyUnlocked === true) {
        this.$refs.outlier1.style.opacity = '0'
        this.$refs.outlier2.style.opacity = '0'
        this.$refs.outlier3.style.opacity = '0'
        this.$refs.outlier4.style.opacity = '0'
      } else if (times >= 5) {
        this.$refs.outlier1.style.opacity = '1'
        this.$refs.outlier2.style.opacity = '1'
        this.$refs.outlier3.style.opacity = '1'
        this.$refs.outlier4.style.opacity = '1'
      } else if (times >= 4) {
        this.$refs.outlier1.style.opacity = '1'
        this.$refs.outlier2.style.opacity = '1'
        this.$refs.outlier3.style.opacity = '0.5'
        this.$refs.outlier4.style.opacity = '0.2'
      } else if (times >= 3) {
        this.$refs.outlier1.style.opacity = '1'
        this.$refs.outlier2.style.opacity = '0.5'
        this.$refs.outlier3.style.opacity = '0.2'
      } else if (times >= 2) {
        this.$refs.outlier1.style.opacity = '0.5'
        this.$refs.outlier2.style.opacity = '0.2'
      } else if (times >= 1) {
        this.$refs.outlier1.style.opacity = '0.2'
      }
    }
  },
  components: {
    Countdown,
    EpisodeTitle
  },
  computed: {
    episode () {
      if (!this.$attrs.episode) {
        return '1'
      } else if (this.$attrs.episode > this.$root.progress.episode && !this.$root.progress.debug && !this.$root.progress.finished) {
        return this.$root.progress.episode.toString()
      } else {
        return this.$attrs.episode
      }
    },
    chapter () {
      if (!this.$attrs.chapter) {
        return '1'
      } else if (this.$attrs.chapter > this.$root.progress.chapter && !this.$root.progress.debug && !this.$root.progress.finished && parseInt(this.episode) === this.$root.progress.episode) {
        return this.$root.progress.chapter.toString()
      } else {
        return this.$attrs.chapter
      }
    },
    currentChapter () {
      return this.episodes[this.episode].chapters[this.chapter]
    },
    chapterId () {
      return this.currentChapter.id
    },
    locationId () {
      return this.currentChapter.location
    },
    locationIsSet () {
      if (this.$root.locations[this.locationId] || this.locationId === 0) {
        return true
      }
      return false
    },
    episodeEnded () {
      return this.$root.progress.episodeEnded
    },
    deadline () {
      if (!this.episodeEnded) {
        return 0
      }
      var newdeadline = this.episodeEnded + parseInt(this.$root.progress.episode_interval) * 60 * 1000
      return newdeadline
    },
    episodeTitle () {
      var id = parseInt(this.episode)
      var num
      if (id === 1) {
        num = 'I'
      } else if (id === 2) {
        num = 'II'
      } else if (id === 3) {
        num = 'III'
      } else if (id === 4) {
        num = 'IV'
      } else if (id === 5) {
        num = 'Five'
      }
      return 'Episode ' + num
    }
  },
  methods: {
    episodeUnlock () {
      this.timerUnlocked = false
      this.storyUnlocked = true
    },
    episodeLock () {
      this.timerUnlocked = true
      this.storyUnlocked = false
    },
    goBack: function () {
      this.$router.go(-1)
    },
    read () {
      this.$router.replace({ name: 'Chapter', params: { episode: this.episode, chapter: this.chapter } })
    },
    checkIn () {
      var database = firebase.database()
      var auth = firebase.auth()
      var locationId = this.locationId
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
      var success = (pos) => {
        var crd = pos.coords
        this.$alertify.confirm('Are you sure you wish to set this location?', () => {
          database.ref('/users/' + auth.currentUser.uid + '/locations/' + locationId).set({ lat: crd.latitude, lon: crd.longitude })
          this.inLocation = true
        }).set({
          title: 'Are you there'
        }).set({
          labels: {
            ok: 'Set',
            cancel: 'Cancel'
          }
        })
      }
      var error = (err) => {
        this.showError(err.code)
      }
      navigator.geolocation.getCurrentPosition(success, error, options)
    },
    startReading () {
      this.$router.replace('/chapter/' + this.episode + '/' + this.chapter)
    },
    compareLocation (currentLat, currentLon, storedLat, storedLon, r) {
      var lat = currentLat
      var lon = currentLon
      var x = storedLat
      var y = storedLon
      r = 0.00035
      var distPoints = (lat - x) * (lat - x) + (lon - y) * (lon - y)
      r *= r
      if (distPoints < r) {
        return true
      }
      return false
    },
    checkLocation () {
      var database = firebase.database()
      var auth = firebase.auth()
      var locationId = this.locationId
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
      var getStoredLat = database.ref('/users/' + auth.currentUser.uid + '/locations/' + locationId + '/lat').once('value')
        .then(function (snap) {
          return snap.val()
        })
      var getStoredLon = database.ref('/users/' + auth.currentUser.uid + '/locations/' + locationId + '/lon').once('value')
        .then(function (snap) {
          return snap.val()
        })
      var getPosition = function (options) {
        return new Promise(function (resolve, reject) {
          navigator.geolocation.getCurrentPosition(resolve, reject, options)
        })
      }
      Promise.all([
        getStoredLat,
        getStoredLon,
        getPosition(options)
      ])
        .then((values) => {
          var lat = values[2].coords.latitude
          var lon = values[2].coords.longitude
          var latStored = values[0]
          var lonStored = values[1]
          this.showError(0)
          this.inLocation = this.compareLocation(lat, lon, latStored, lonStored)
          if (!this.inLocation) {
            this.showError(4)
            this.timesChecked++
          }
        })
        .catch((err) => {
          this.showError(err.code)
        })
    },
    showError (code) {
      var message = null
      if (code === 1) {
        message = 'You have not enabled permissions. Check you have allowed location access to the site and the browser in your settings'
      } else if (code === 2) {
        message = 'Your position is currently unavailable. Please make sure your location settings are turned on'
      } else if (code === 3) {
        message = 'Getting location has timed out, please try again'
      } else if (code === 4) {
        message = 'It doesn\'t look like you\'re there just yet. Try and get closer'
      }
      this.errorMsg = message
    }
  },
  created () {
    firebase.database().ref('/users/' + firebase.auth().currentUser.uid + '/progress').update({
      welcome: false
    })
  },
  mounted () {
    const dateInt = setInterval(() => {
      if (this.deadline !== 0) {
        if (this.deadline - Date.parse(new Date()) <= 0) {
          this.episodeUnlock()
        } else {
          if (parseInt(this.episode) === parseInt(this.$root.progress.episode) && this.$root.progress.finished !== true) {
            this.episodeLock()
          } else {
            this.episodeUnlock()
          }
        }
        clearInterval(dateInt)
      }
    },
    50)
  }
}
</script>

<style lang="css" scoped>
.outliers span {
  opacity: 0;
  transition: opacity 1s ease-in;
}
</style>
